import AsyncDialog from "./asyncDialog";

const $ = jQuery;

// Dialog to prompt a user for what they want to do with an attachment.
const ACTION_REMOVE = "remove";
const ACTION_DOWNLOAD = "download";
const ACTION_REPLACE = "replace";
const ACTION_CANCEL = "cancel";

function makeButton(text, result) {
    return $("<input type='button' />")
        .attr("value", text)
        .addClass("ui-button")
        .data("result", result);
}

function makeUi(dialog, fileName) {
    var myUi = $("<div>")
        .attr("title", "What do you want to do with " + fileName + "?")
        .append(makeButton("Remove", ACTION_REMOVE))
        .append(makeButton("Download", ACTION_DOWNLOAD))
        .append(makeButton("Replace", ACTION_REPLACE))
        .append(makeButton("Cancel", ACTION_CANCEL));

    myUi.on("click", "input", function (e) {
        dialog.closeWithResult($(e.target).data("result"));
    });

    return myUi;
}

const showFileActionDialog = (fileName) => {
    const dialog = new AsyncDialog();

    dialog.class = "fv-file-action-dialog";
    dialog.setTarget(makeUi(dialog, fileName));

    return dialog.showAsync();
};

export {
    ACTION_REMOVE,
    ACTION_DOWNLOAD,
    ACTION_REPLACE,
    ACTION_CANCEL,
};

export default showFileActionDialog;